import type { ConstValues } from '@openx/types/helpers.ts';
/**
 * All query keys used by react-query.
 */
export const QueryKeys = {
  ACCOUNT: 'ACCOUNT',
  ACCOUNTS: 'ACCOUNTS',
  ACCOUNT_RTB_ENDPOINTS: 'ACCOUNT_RTB_ENDPOINTS',
  ADS: 'ADS',
  ADUNIT: 'ADUNIT',
  AD_FILTERS: 'AD_FILTERS',
  AD_FILTERS_LIST_ACCOUNTS: 'AD_FILTERS_LIST_ACCOUNTS',
  APP_GROUP: 'APP_GROUP',
  AQ_RULE: 'AQ_RULE',
  AQ_RULES: 'AQ_RULES',
  AUDIENCE: 'AUDIENCE',
  AUDIENCE_SHARE_RECIPIENTS: 'AUDIENCE_SHARE_RECIPIENTS',
  AUDIT_TRAILS: 'AUDIT_TRAILS',
  BLOCKED_SEATS: 'BLOCKED_SEATS',
  BRANDS: 'BRANDS',
  BRAND_FEE_CAPS: 'BRAND_FEE_CAPS',
  BRAND_FLOORS: 'BRAND_FLOORS',
  BREAKDOWN: 'BREAKDOWN',
  COMMERCIAL_AGREEMENT: 'COMMERCIAL_AGREEMENT',
  BUYER: 'BUYER',
  CONTEXTUAL_PRICING: 'CONTEXTUAL_PRICING',
  CREATIVES: 'CREATIVES',
  CREATIVE_REVIEW: 'CREATIVE_REVIEW',
  CURATION_INSIGHTS: 'CURATION_INSIGHTS',
  CURATION_INSIGHTS_FILTER_OPTIONS: 'CURATION_INSIGHTS_FILTER_OPTIONS',
  CURRENT_ACCOUNT_COOKIE_MAPPING_URL_TEMPLATE: 'CURRENT_ACCOUNT_COOKIE_MAPPING_URL_TEMPLATE',
  CURRENT_ACCOUNT_EXCHANGE_PAYMENTS_HISTORY: 'CURRENT_ACCOUNT_EXCHANGE_PAYMENTS_HISTORY',
  CURRENT_ACCOUNT_REMAINING_MONTHLY_BUDGET: 'CURRENT_ACCOUNT_REMAINING_MONTHLY_BUDGET',
  CURRENT_ACCOUNT_RTB_DATA_URL_TEMPLATE: 'CURRENT_ACCOUNT_RTB_DATA_URL_TEMPLATE',
  CURRENT_USER_EMAILS: 'CURRENT_USER_EMAILS',
  CUSTOMER: 'CUSTOMER',
  DEAL: 'DEAL',
  DEALS: 'DEALS',
  DEAL_FORECASTING: 'DEAL_FORECASTING',
  DEAL_INSIGHTS: 'DEAL_INSIGHTS',
  DEAL_INSIGHTS_FILTER_OPTIONS: 'DEAL_INSIGHTS_FILTER_OPTIONS',
  DEAL_INSIGHTS_JOB_ID: 'DEAL_INSIGHTS_JOB_ID',
  DEAL_INSIGHTS_SECTION: 'DEAL_INSIGHTS_SECTION',
  DEAL_LANDING: 'DEAL_LANDING',
  DEAL_LIBRARY: 'DEAL_LIBRARY',
  DEAL_REVENUE_CALCULATOR: 'DEAL_REVENUE_CALCULATOR',
  DEAL_TROUBLESHOOTING_AGENT: 'DEAL_TROUBLESHOOTING_AGENT',
  DEAL_TROUBLESHOOTING_FUNNEL: 'DEAL_TROUBLESHOOTING_FUNNEL',
  DEAL_TROUBLESHOOTING_FUNNEL_JOB_ID: 'DEAL_TROUBLESHOOTING_FUNNEL_JOB_ID',
  DEFAULT_MARKET: 'DEFAULT_MARKET',
  FEDERATED_API: 'FEDERATED_API',
  FEES: 'FEES',
  FEE_SCHEDULE: 'FEE_SCHEDULE',
  FLOOR_PACKAGES: 'FLOOR_PACKAGES',
  GLOBAL_FEE_PUBLISHER_PMP: 'GLOBAL_FEE_PUBLISHER_PMP',
  GLOBAL_SEARCH: 'GLOBAL_SEARCH',
  GRANULAR_DSP_FEE: 'GRANULAR_DSP_FEE',
  INVENTORIES: 'INVENTORIES',
  KEYWORDS: 'KEYWORDS',
  LINEITEM: 'LINEITEM',
  LINE_ITEMS: 'LINE_ITEMS',
  LIST_ADUNITS: 'LIST_ADUNITS',
  LIST_PMP_PUBLISHER_FEES: 'LIST_PMP_PUBLISHER_FEES',
  MARKET: 'MARKET',
  MARKET_OPERATORS: 'MARKET_OPERATORS',
  METACATEGORY: 'METACATEGORY',
  MONETIZING: 'MONETIZING',
  NETWORK_ACCOUNT_CURRENCIES: 'NETWORK_ACCOUNT_CURRENCY',
  OPTIONS_LIST: 'OPTIONS_LIST',
  ORDER: 'ORDER',
  ORGANIZATION_USERS: 'ORGANIZATION_USERS',
  PACKAGES: 'PACKAGES',
  PACKAGE_DEALS: 'PACKAGE_DEALS',
  PACKAGE_FLOORS: 'PACKAGE_FLOORS',
  PACKAGE_USED_BY: 'PACKAGE_USED_BY',
  PERFORMANCE_METRICS: 'PERFORMANCE_METRICS',
  PIXEL_METRICS: 'PIXEL_METRICS',
  POST_AUCTION_DISCOUNTS: 'POST_AUCTION_DISCOUNTS',
  PRICING_RULES: 'PRICING_RULES',
  PUBLISHER_FEE_CAPS: 'PUBLISHER_FEE_CAPS',
  REBATE: 'REBATE',
  REBATE_EXCLUSION_MANAGER: 'REBATE_EXCLUSION_MANAGER',
  RECONCILIATION_PARTNER: 'RECONCILIATION_PARTNER',
  RELATED_ACCOUNTS: 'RELATED_ACCOUNTS',
  RETARGETING_SEGMENTS: 'RETARGETING_SEGMENTS',
  RETARGETING_SEGMENT_BY_ID: 'RETARGETING_SEGMENT_BY_ID',
  SEARCH: 'SEARCH',
  SESSION: 'SESSION',
  SEATS: 'SEATS',
  SEAT_FEE_CAPS: 'SEAT_FEE_CAPS',
  SEAT_FEE_CAP_ITEMS: 'SEAT_FEE_CAP_ITEMS',
  SEAT_OBSERVED_BRANDS: 'SEAT_OBSERVED_BRANDS',
  SIMILAR_CREATIVES: 'SIMILAR_CREATIVES',
  SITE: 'SITE',
  SITES: 'SITES',
  SUB_ACCOUNTS: 'SUB_ACCOUNTS',
  TARGETING: 'TARGETING',
  TPF_BOOSTED_BID_PRICE: 'TPF_BOOSTED_BID_PRICE',
  TRAFFIC_SETS_DEMAND_PARTNERS: 'TRAFFIC_SETS_DEMAND_PARTNERS',
  TRAFFIC_STATS: 'TRAFFIC_STATS',
  TROUBLESHOOTING: 'TROUBLESHOOTING',
  USERS: 'USERS',
  USER_COMMENTS: 'USER_COMMENTS',
} as const;

export type QueryKeysValues = ConstValues<typeof QueryKeys>;
